var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendOtpNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.503,
    height: 20.584,
    viewBox: "0 0 20.503 20.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3700",
    "data-name": "Group 3700",
    transform: "translate(-411.746 -1261.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3697",
    "data-name": "Group 3697",
    transform: "translate(35 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3694",
    "data-name": "Group 3694",
    transform: "translate(-107 -68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3690",
    "data-name": "Group 3690",
    transform: "translate(480.041 1330.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23845",
    "data-name": "Path 23845",
    d: "M10.948,18.73c-3.32-1.118-5.444-3.934-5.283-7s2.574-5.706,6-6.56a.649.649,0,0,0,.14.94.934.934,0,0,0,1.1,0l1.664-1.434a.649.649,0,0,0,0-1.018L12.9,2.222a.932.932,0,0,0-1.129.038.647.647,0,0,0-.044.973l.416.358C7.748,4.284,4.421,7.413,4,11.248s2.175,7.443,6.346,8.83a.943.943,0,0,0,.846-.088.671.671,0,0,0,.311-.684.757.757,0,0,0-.551-.561Z",
    transform: "translate(0 0)",
    fill: "#E10092",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23846",
    "data-name": "Path 23846",
    d: "M25.814,12.819C25.83,9.27,23.3,6.081,19.458,4.8a.876.876,0,0,0-1.044.416.684.684,0,0,0,.437.917c3.32,1.118,5.444,3.934,5.283,7s-2.574,5.706-6,6.56a.645.645,0,0,0-.058-.939.929.929,0,0,0-1.173,0L15.24,20.195a.649.649,0,0,0,0,1.018L16.9,22.646a.932.932,0,0,0,1.129-.038.647.647,0,0,0,.044-.973l-.416-.358c4.727-.76,8.154-4.315,8.153-8.458Z",
    transform: "translate(-1.855 -0.769)",
    fill: "#E10092",
    stroke: "#fff",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3699",
    "data-name": "Group 3699",
    transform: "translate(-25 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    transform: "translate(442 1272)",
    fill: "none",
    stroke: "#E10092",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    transform: "translate(446 1272)",
    fill: "none",
    stroke: "#E10092",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    transform: "translate(450 1272)",
    fill: "none",
    stroke: "#E10092",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.5,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendOtpNew);
export default __webpack_public_path__ + "static/media/resend-otp-new.2fc103cfc2cbfe3c5413d8766ec05604.svg";
export { ForwardRef as ReactComponent };